
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'InfoPopup',
  emits: ['closePopup']
})
